<template>
  <div>
    <b-modal
      size="lg"
      centered
      id="modal-add-product"
      hide-footer
      header-class="no-border"
      body-class="no-border"
      modal-class="modalStyle"
      ref="modal-add-product"
    >
      <div class="modalBody">
        <b-row class="imageArea">
          <label for="image" class="cursor">
            <div>
              <div v-if="!imageSelected">
                <div class="btn-addImage">
                  <b-icon icon="card-image" font-scale="4.5"></b-icon>
                  <span>Adicionar Imagem</span>
                </div>
              </div>
              <div v-else>
                <img
                  :src="imagePreview"
                  alt="Produto"
                  style="cursor: pointer"
                  class="container-image-product"
                />
              </div>
            </div>
          </label>
          <div class="image">
            <b-form-file
              name="image"
              id="image"
              class="arquivo"
              v-model="product.image"
              accept="image/*"
              @change="selectImage"
              ref="imageInput"
            />
          </div>
          <div @click="limparImagem" class="cursor">
            <b-icon-trash-fill></b-icon-trash-fill>
          </div>
        </b-row>

        <b-row class="formsArea">
          <b-form @submit.prevent="handleSubmit">
            <label class="mt-3 labels">Nome</label>
            <b-form-input
              type="text"
              id="input-type"
              v-model="product.type"
              :state="validateState('type')"
              aria-describedby="input-1-live-feedback"
            ></b-form-input>
            <b-form-invalid-feedback id="input-1-live-feedback"
              >Campo obrigatório</b-form-invalid-feedback
            >
          </b-form>

          <b-form @submit.prevent="handleSubmit">
            <label class="mt-3 labels">Descrição</label>
            <b-form-textarea
              rows="4"
              type="text"
              class="input-description"
              v-model="product.description"
              :state="validateState('description')"
              aria-describedby="input-2-live-feedback"
            ></b-form-textarea>
            <b-form-invalid-feedback id="input-2-live-feedback"
              >Campo obrigatório</b-form-invalid-feedback
            >
          </b-form>
        </b-row>
      </div>

      <div class="modalFooter">
        <b-row class="alinhamentoLinha">
          <b-button class="button btn-cancel" @click="cancel()"
            >Cancelar</b-button
          >
          <b-button
            class="button btn-save"
            type="submit"
            variant="primary"
            @click="handleSubmit"
            >Salvar</b-button
          >
        </b-row>
      </div>
    </b-modal>
    <ModalConfirmProduct
      ref="modalConfirmProduct"
      @responseModalConfirmProduct="responseModal($event)"
    />
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import ModalConfirmProduct from './ModalConfirmProduct.vue';
import { AddProduct } from '../../services/Product';
import showError from '../../utils/showError';

export default {
  components: { ModalConfirmProduct },
  mixins: [validationMixin],
  data() {
    return {
      isLoading: true,
      isConfirm: true,
      nomeImagem: null,
      imageSelected: false,
      imagePreview: null,
      product: {
        type: null,
        description: null,
        image: null,
      },
    };
  },
  validations: {
    product: {
      type: {
        required,
      },
      description: {
        required,
      },
    },
  },
  methods: {
    handleSubmit() {
      this.$v.product.$touch();
      if (this.$v.product.$anyError) {
        return;
      }
      this.$refs.modalConfirmProduct.isConfirm = true;
      this.$bvModal.show('modal-confirm-product');
    },
    cancel() {
      this.$refs.modalConfirmProduct.isConfirm = false;
      this.$bvModal.show('modal-confirm-product');
    },
    async responseModal(event) {
      if (event) {
        this.isLoading = true; // Ativar indicador de carregamento

        const formData = new FormData();
        formData.append('image', this.product.image);
        formData.append('type', this.product.type);
        formData.append('description', this.product.description);

        try {
          await AddProduct(formData);
          this.$bvModal.hide('modal-confirm-product');
          this.$bvModal.hide('modal-add-product');
          this.$toasted.global.defaultSuccess();
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } catch (error) {
          showError(error);
        } finally {
          this.isLoading = false; // Desativar indicador de carregamento
        }
      }

      this.$bvModal.hide('modal-confirm-product');
      this.resetForm();
    },

    selectImage(event) {
      const image = event.target.files[0];
      this.nomeImagem = image.name;
      this.product.image = image;

      if (this.product.image) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imagePreview = e.target.result;
        };
        reader.readAsDataURL(image);
        this.imageSelected = true;
      }
    },

    limparImagem() {
      this.product.image = null;
      this.nomeImagem = null;
      this.imageSelected = false;
      this.imagePreview = null;
    },
    validateState(type) {
      const { $dirty, $error } = this.$v.product[type];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.product = {
        type: null,
        description: null,
        image: null,
      };
      this.limparImagem();
      this.$nextTick(() => {
        this.$v.$reset();
      });
      this.$bvModal.hide('modal-add-product');
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .no-border {
  border: none;
}
::v-deep .modalStyle > .modal-dialog > .modal-content {
  background-color: #be8250;
  border-radius: 20px;
  color: #eeeeee;
}
.modalBody {
  display: grid;
  grid-template-columns: 1fr 2fr;
  grid-gap: 20px;
}

.imageArea {
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
}
.cursor {
  cursor: pointer;
}

.btn-addImage {
  background-color: #eeeeee;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  border-radius: 8px;
  color: #be8250;
  padding: 1rem;
  height: 193px;
  width: 150px;
}
.arquivo {
  display: none;
}
.selectedImage {
  text-align: center;
}

.container-image-product {
  height: 193px;
  width: 150px;
  border-radius: 8px;
  background-color: #fff;

  display: flex;
  justify-content: center;
  align-items: center;
}

.formsArea {
  display: inline;
  padding-right: 25px;
  margin-top: -20px;
}
.form-control {
  background-color: #eeeeee;
  border-radius: 11px;
}

.modalFooter {
  margin-top: 30px;
}
.alinhamentoLinha {
  display: flex;
  justify-content: flex-end;
  margin-right: 0.5rem !important;
}
.button {
  height: 32px;
  cursor: pointer;
  color: #ffffff;
  border-radius: 22px;
  border: none;
  width: 124px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn-cancel {
  background-color: #d12c38;
}
.btn-save {
  background-color: #169933;
  margin-left: 18px;
}
</style>
